// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* To avoid collision with matsnackbar in push notify, to be sure that it is exclusive only to toast*/
.mat-snack-bar-container:not(.notify-panel) {
   padding: 0em;
}

.toast-info {
   background: #56c0e0;
}

.toast-success {
   background: #1bbf89;
}

.toast-warn {
   background: #f7af3e;
   color: #222;
}

.toast-error {
   background: #db524b;
}
app-toast {
  display: flex;
  justify-content: space-between;
  line-height: 24px;
  padding: 1em;
}
app-toast mat-icon {
  margin-right: 5px;
  overflow: unset;
}

.toast-action {
   -webkit-user-select: none;
   user-select: none;
   cursor: pointer;
   outline: 0;
   border: none;
   -webkit-tap-highlight-color: transparent;
   background: none;
   color: rgba(255, 255, 255, .8);
   flex-shrink: 0;
   margin-left: 48px;
   padding: 4px 10px;
}

button.toast-action:hover {
   background: none;
}

button.toast-action:active {
   background: rgba(0, 0, 0, .1);
}

.flex-item {
   word-break: break-word;
}

.mat-icon {
   -webkit-user-select: none;
   user-select: none;
   background-repeat: no-repeat;
   display: inline-block;
   fill: currentColor;
   height: 24px;
   width: 24px;
   overflow: unset;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/toast/toast.component.css"],"names":[],"mappings":"AAAA,qGAAqG;AACrG;GACG,YAAY;AACf;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,mBAAmB;GACnB,WAAW;AACd;;AAEA;GACG,mBAAmB;AACtB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;GACG,yBAAyB;GAGzB,iBAAiB;GACjB,eAAe;GACf,UAAU;GACV,YAAY;GACZ,wCAAwC;GACxC,gBAAgB;GAChB,8BAA8B;GAC9B,cAAc;GACd,iBAAiB;GACjB,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,6BAA6B;AAChC;;AAEA;GACG,sBAAsB;AACzB;;AAEA;GACG,yBAAyB;GACzB,iBAAiB;GACjB,4BAA4B;GAC5B,qBAAqB;GACrB,kBAAkB;GAClB,YAAY;GACZ,WAAW;GACX,eAAe;AAClB","sourcesContent":["/* To avoid collision with matsnackbar in push notify, to be sure that it is exclusive only to toast*/\n.mat-snack-bar-container:not(.notify-panel) {\n   padding: 0em;\n}\n\n.toast-info {\n   background: #56c0e0;\n}\n\n.toast-success {\n   background: #1bbf89;\n}\n\n.toast-warn {\n   background: #f7af3e;\n   color: #222;\n}\n\n.toast-error {\n   background: #db524b;\n}\napp-toast {\n  display: flex;\n  justify-content: space-between;\n  line-height: 24px;\n  padding: 1em;\n}\napp-toast mat-icon {\n  margin-right: 5px;\n  overflow: unset;\n}\n\n.toast-action {\n   -webkit-user-select: none;\n   -moz-user-select: none;\n   -ms-user-select: none;\n   user-select: none;\n   cursor: pointer;\n   outline: 0;\n   border: none;\n   -webkit-tap-highlight-color: transparent;\n   background: none;\n   color: rgba(255, 255, 255, .8);\n   flex-shrink: 0;\n   margin-left: 48px;\n   padding: 4px 10px;\n}\n\nbutton.toast-action:hover {\n   background: none;\n}\n\nbutton.toast-action:active {\n   background: rgba(0, 0, 0, .1);\n}\n\n.flex-item {\n   word-break: break-word;\n}\n\n.mat-icon {\n   -webkit-user-select: none;\n   user-select: none;\n   background-repeat: no-repeat;\n   display: inline-block;\n   fill: currentColor;\n   height: 24px;\n   width: 24px;\n   overflow: unset;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
